import RadioGroupFormField from '../../radio-group-form-field';
import { jsx as _jsx } from "react/jsx-runtime";
var ratingOptions = [{
  label: '0',
  value: '0'
}, {
  label: '1',
  value: '1'
}, {
  label: '2',
  value: '2'
}, {
  label: '3',
  value: '3'
}, {
  label: '4',
  value: '4'
}, {
  label: '5',
  value: '5'
}, {
  label: '6',
  value: '6'
}, {
  label: '7',
  value: '7'
}, {
  label: '8',
  value: '8'
}, {
  label: '9',
  value: '9'
}, {
  label: '10',
  value: '10'
}];

var RatingInput = function RatingInput(_ref) {
  var name = _ref.name,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$questionForm = _ref.questionForm,
      control = _ref$questionForm.control,
      errors = _ref$questionForm.formState.errors;
  return /*#__PURE__*/_jsx(RadioGroupFormField, {
    control: control,
    name: name,
    required: required,
    options: ratingOptions,
    error: errors[name],
    labelPlacement: "bottom",
    row: true,
    "data-element": "RadioGroupFormField",
    "data-component": "RatingInput",
    "data-source-file": "rating.tsx"
  });
};

export default RatingInput;